import Vue from "vue";
import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS,
  ICON_LIST_FIXED,
  LIST_DATA_EVENTS,
  SERVICES_ACCESS
} from "@/shared/constants/FormConstants";
import {
  SNACKBAR_STYLE,
  STYLE_CLASSES
} from "@/shared/constants/StyleConstants";
import AddSectionGroup from "./AddSectionGroup/AddSectionGroup.vue";
import { SectionGroup } from "../../models/SectionGroup";
import { SectionGroupDetail } from "../../models/SectionGroupDetail";
import { ListService } from "@/modules/List/services/ListService";
import { Http } from "@status/codes";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { ServiceTemplateService } from "../../services/ServiceTemplateService";
import {
  EMITS,
  SERVICE_TEMPLATES_ACCESS,
  SERVICE_TEMP_CONSTANTS
} from "../../constants/ServiceTemplateConstants";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { ServiceTemplateModel } from "../../models/ServiceTemplateModel";
import StepperViewer from "../StepperViewer/StepperViewer.vue";
import { UserService } from "../../../User/services/UserService";
import {
  USER_CONSTANTS,
  QUERY_STATE_ACTIVE,
  USER_MESSAGES
} from "../../../User/constants/UserConstants";
import { USER_TEMP_CONSTANTS } from "../../../UserTemplate/constants/UserTemplateConstants";
import { UserTemplateService } from "../../../UserTemplate/services/UserTemplateService";
import { FormTemplateService } from "../../../FormTemplate/services/FormTemplateService";
import { Utils } from "@/shared/utils/utils";
import InfoModalTemplate from "../../../../shared/components/InfoModalTemplate/InfoModalTemplate.vue";
import { InfoGroupService } from "../../../InfoGroup/services/InfoGroupService";
import {
  INFO_GROUPS_ACCESS,
  INFO_GROUP_CONSTANTS
} from "../../../InfoGroup/constants/InfoGroupConstants";
import { CupsPriceLevelService } from "../../../CupsPriceLevels/services/CupsPriceLevelService";
import { CupsPriceLevelHeader } from "@/modules/CupsPriceLevels/models/CupsPriceLevelHeader";
import { NotificationParams } from "@/modules/Notification/models/NotificationParams";
import { RolesService } from "../../../Roles/services/RolesService";
import { RoleInfo } from "../../../Roles/models/RoleInfo";
import { FieldOrder } from "@/modules/Orders/models/FieldOrder";
import { OrderService } from "@/modules/Orders/services/OrderService";
import { Icon } from "@/shared/models/Icon";
import {
  GENERAL_CONSTANTS,
  MANAGED_LISTS_TYPES,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { ManagedListsService } from "@/shared/services/ManagedListsService";
import ChipFomList from "@/shared/components/ChipFomList/ChipFomList.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { CupsPriceLevelFilter } from "@/modules/CupsPriceLevels/models/CupsPriceLevelFilter.model";
import { PreventKey } from "@/shared/mixins/mixins";
import { SearchContextModal } from "@/shared/models/SearchContextModal";
import SaveCupsPriceLevel from "../../../CupsPriceLevels/components/SaveCupsPriceLevel/SaveCupsPriceLevel.vue";
import SaveSessionTemplate from "../../../SessionTemplate/components/SaveSessionTemplate/SaveSessionTemplate.vue";
import SaveFormTemplate from "../../../FormTemplate/components/SaveFormTemplate/SaveFormTemplate.vue";
import { AxiosError } from "axios";
import { CUPS_ACCESS } from "@/modules/CupsPriceLevels/constants/CupsPriceLevelConstants";
import { ROLES_ACCESS } from "@/modules/Roles/constants/RoleConstants";
import { CampusQuery } from "@/modules/Campus/models/CampusQuery";
import { CampusService } from "@/modules/Campus/services/CampusService";
import { CampusModel } from "@/modules/Campus/models/CampusModel";
import { CAMPUS_ACCESS } from "@/modules/Campus/constants/CampusConstants";
import { mapGetters } from "vuex";
import store from "@/store";
import { AvailabilityService } from "@/modules/Availability/services/AvailabilityService";
import { AvailabilityTemplateIdNameModel } from "@/modules/Availability/models/AvailibilityIdNameModel";
import { AVAILIABILITY_ACCESS } from "@/modules/Availability/constants/AvailabilityConstants";
import { AvailabilityTemplateService } from "@/modules/AvailabilityTemplate/services/AvailabilityTemplateService";
import { CampusIdName } from "@/modules/Campus/models/CampusIdName.Model";
import { AvailabilityTemplate } from "@/modules/AvailabilityTemplate/models/AvailabilityTemplateModel";
import { ServiceTemplateForm } from "../../models/ServiceTemplateForm.model";

Vue.use(Vuetify);

@Component({
  name: "SaveServiceTemplate",
  components: {
    AddSectionGroup,
    ModalTemplate,
    EmptyState,
    StepperViewer,
    ChipFomList,
    DynamicSelect,
    InfoModalTemplate,
    SaveCupsPriceLevel,
    SaveSessionTemplate,
    SaveFormTemplate
  },
  computed: {
    ...mapGetters({
      campusServiceTemplate: "getCampusServiceTemplate"
    })
  }
})
export default class SaveServiceTemplate extends PreventKey {
  @Inject() serviceTemplateService!: ServiceTemplateService;
  @Inject() listService!: ListService;
  @Inject() userService!: UserService;
  @Inject() userTemplateService!: UserTemplateService;
  @Inject() formTemplateService!: FormTemplateService;
  @Inject() infoGroupService!: InfoGroupService;
  @Inject() cupsPriceLevelService!: CupsPriceLevelService;
  @Inject() rolesService!: RolesService;
  @Inject() orderService!: OrderService;
  @Inject() managedListsService!: ManagedListsService;
  @Inject() campusService!: CampusService;
  @Inject() availabilityService!: AvailabilityService;
  @Inject() availabilityTemplateService!: AvailabilityTemplateService;

  @Prop() documentId?: string;
  @Prop() serviceCategoryList?: string[];
  @Prop({ default: false, required: false })
  public isModal!: boolean;

  TITLE = SERVICE_TEMP_CONSTANTS.TITLE.ADD_TEMPLATE;
  SAVE_BUTTON = FORM_CONSTANTS.BUTTON.SAVE;
  CANCEL_BUTTON = FORM_CONSTANTS.BUTTON.CANCEL;
  PRICE_BUTTON = SERVICE_TEMP_CONSTANTS.BUTTONS_CREATE_TEMP.PRICE_LEVEL;
  PREVIEW_BTN = FORM_CONSTANTS.BUTTON.PREVIEW;
  CATEGORY_LABEL = SERVICE_TEMP_CONSTANTS.LABELS_CREATE_TEMP.CATEGORY;
  NAME_LABEL = SERVICE_TEMP_CONSTANTS.LABELS_CREATE_TEMP.NAME;
  ALIAS_LABEL = SERVICE_TEMP_CONSTANTS.LABELS_CREATE_TEMP.ALIAS;
  TYPE_LABEL = SERVICE_TEMP_CONSTANTS.LABELS_CREATE_TEMP.TYPE;
  DESCRIPTION_LABEL = SERVICE_TEMP_CONSTANTS.LABELS_CREATE_TEMP.DESCRIPTION;
  CUPS = SERVICE_TEMP_CONSTANTS.LABELS_CREATE_TEMP.CUPS;
  SECTIONS_GROUPS_TEXT = SERVICE_TEMP_CONSTANTS.TITLE.SECTION;
  EMPTY_HEADER = SERVICE_TEMP_CONSTANTS.EMPTY_STATE.SECTION.HEADER;
  EMPTY_TEXT = SERVICE_TEMP_CONSTANTS.EMPTY_STATE.SECTION.TEXT;
  EMPTY_HEADER_SESSION = SERVICE_TEMP_CONSTANTS.EMPTY_STATE.SESSION.HEADER;
  EMPTY_TEXT_SESSION = SERVICE_TEMP_CONSTANTS.EMPTY_STATE.SESSION.TEXT;
  EMPTY_HEADER_FORM = SERVICE_TEMP_CONSTANTS.EMPTY_STATE.FORMS.HEADER;
  EMPTY_TEXT_FORM = SERVICE_TEMP_CONSTANTS.EMPTY_STATE.FORMS.TEXT;
  EMPTY_RULES_HEADER = SERVICE_TEMP_CONSTANTS.EMPTY_STATE.RULES.HEADER;
  EMPTY_RULES_TEXT = SERVICE_TEMP_CONSTANTS.EMPTY_STATE.RULES.TEXT;
  RULES_BTN = SERVICE_TEMP_CONSTANTS.BUTTONS_CREATE_TEMP.ADD_RULE;
  RULES_TEXT = SERVICE_TEMP_CONSTANTS.TITLE.RULES;
  HINT_CUPS = SERVICE_TEMP_CONSTANTS.LABEL.HINT_CUPS;
  SEARCH_CUPS = SERVICE_TEMP_CONSTANTS.LABEL.SEARCH_CUPS;
  COMPONENT_NAME_MODAL = COMPONENT_NAME_MODAL;
  FILL_BY_STEP_LABEL =
    SERVICE_TEMP_CONSTANTS.LABELS_CREATE_TEMP.FILL_BY_STEP_LABEL +
    this.SECTIONS_GROUPS_TEXT.toLowerCase();
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  MORE_INFO = FORM_CONSTANTS.BUTTON.MORE_INFO;
  ADITIONAL_INFO = SERVICE_TEMP_CONSTANTS.LABEL.ADITIONAL_INFO;
  ACTIVE_LABEL = FORM_CONSTANTS.LABEL.STATE;
  AVAILABILITY_COLOR = SERVICE_TEMP_CONSTANTS.LABEL.AVAILABILITY_COLOR;
  AVAILABILITY_RECURRENT = SERVICE_TEMP_CONSTANTS.LABEL.AVAILABILITY_RECURRENT;
  ELEMENT_INACTIVE = STYLE_CLASSES.ELEMENT_INACTIVE;
  MULTIPLE_SERVICES_LABEL =
    SERVICE_TEMP_CONSTANTS.LABEL.MULTIPLE_SERVICES_LABEL;
  ONLINE_APPOINTMENT_LABEL = SERVICE_TEMP_CONSTANTS.LABEL.ONLINE_APPOINTMENT;
  WARNING_COLOR = SNACKBAR_STYLE.WARNING.COLOR;
  STATE = STATE;
  HINT_CUPS_NOT_REQUIRE_PRIOR_ORDER =
    SERVICE_TEMP_CONSTANTS.LABEL.NOT_REQUIRE_PRIOR_ORDER;
  HINT_CUPS_REQUIRE_PRIOR_ORDER =
    SERVICE_TEMP_CONSTANTS.LABEL.REQUIRE_PRIOR_ORDER;
  USER_CAMPUS = USER_CONSTANTS.LABEL.USER_CAMPUS;

  cardClass = STYLE_CLASSES.CARD;
  CLUSTER_TEXT = SERVICE_TEMP_CONSTANTS.TITLE.GROUPS;
  SECTION_TEXT = SERVICE_TEMP_CONSTANTS.TITLE.SECTION;
  roundBtnClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  roundBtnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  switchClass = STYLE_CLASSES.SWITCH;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryButtonClass = STYLE_CLASSES.SECONDARY_BTN;
  textAreaClass = STYLE_CLASSES.TEXT_AREA;

  serviceTypeModel = [{ id: "", name: "" }];
  categoryModel = [{ id: "", name: "" }];
  serviceTypesList = SERVICE_TEMP_CONSTANTS.SERVICE_TYPE_LIST;
  modalTitle = SERVICE_TEMP_CONSTANTS.MODAL_TITLE.SECTION;
  SERVICE_TEMP_CONSTANTS = SERVICE_TEMP_CONSTANTS;

  sectionGroupFill = new SectionGroup();
  serviceTemplateForm = false;
  isEditing = false;
  isEditingContent = false;
  //serviceCategory = "";
  fillByStep = false;
  indexEdit = 0;
  indexDeleteSectionGroup = 0;
  docRef = "";
  addSectionGroupDialog = false;
  dialogConfirmation = false;
  dialogStepperViewer = false;
  dialogModalInfo = false;
  componentStepperViewerKey = 0;
  modalConfirmationText = "";
  modalConfirmationTitle = "";
  modalInfoText = "";
  modalInfoTitle = ";";
  serviceTemplateDataStepper: ServiceTemplateModel = new ServiceTemplateModel();
  category = "";
  listCups: CupsPriceLevelHeader[] = [];
  userInfoParams: NotificationParams[] = [];

  ruleObjectCups = [
    (v: CupsPriceLevelHeader) => !!v.id || FORM_MESSAGES.REQUIRED_FIELD
  ];

  userRoleList: RoleInfo[] = [];
  disabledInputsEdit = false;
  indexDeleteRule = 0;
  fieldsOrder: FieldOrder[] = [];
  iconsList: Icon[] = [];
  showMoreInfo = false;
  menu = false;
  onlineAppointments = false;
  isGettingTemplateData = true;
  activedScroll = false;
  campusObjectRole = [this.selectAtLeastOneCampus];
  availabilityRule = [this.selectAtLeastOneAvailability];
  dynamicSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: [],
    filled: false,
    messageLabel: this.SEARCH_CUPS,
    persistenthint: true,
    hint: this.HINT_CUPS,
    required: true,
    notFound: false,
    loadingData: true,
    chips: true
  };
  serviceSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: this.serviceTypesList.map(element => {
      return { id: element.value, name: element.label };
    }),
    filled: false,
    messageLabel: this.TYPE_LABEL,
    required: true
  };
  categorySelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll:
      this.serviceCategoryList?.map(category => {
        return { id: category, name: category };
      }) || [],
    filled: false,
    messageLabel: this.CATEGORY_LABEL,
    required: true
  };

  availabilitiesStore: AvailabilityTemplateIdNameModel[] = [];
  availabilitySelectConfig: DynamicSelectConfig = {
    multiple: true,
    default: [],
    listAll: [],
    chips: true,
    filled: false,
    messageLabel: "Disponibilidad",
    notFound: false,
    persistenthint: true,
    rules: this.availabilityRule,
    loadingData: true,
    required: true
  };

  dynamicSelectList: DynamicSelectData[] = [];
  cupsLastRef = "";
  deleteCounter = 1;
  modalMessage = "";
  showModalAddCups = false;
  showModalAddForm = false;
  showModalAddSection = false;
  refreshSessionSearch = 0;
  refreshFormSearch = 0;
  errorsName: string[] = [];
  campusLastReference = "";
  availabilityLastReference = "";
  campusFilters: CampusQuery = {};
  campusChosen: CampusModel[] = [];
  campusChoosen: CampusIdName[] = [];
  availabilitiesChosen: AvailabilityTemplateIdNameModel[] = [];
  listCampus: CampusModel[] = [];
  showModalCampus = false;
  campusServiceTemplate!: boolean;
  lastAvailabilityRef = "";
  keyWordAvailabiltyName = "";

  serviceTemplateFormData: ServiceTemplateForm = {
    multipleInstances: false,
    serviceName: "",
    aliasName: "",
    serviceType: "",
    serviceCategory: "",
    serviceDescription: "",
    serviceAvailabilityColor: "",
    serviceAvailabilityRecurrent: 0,
    colorPicked: "",
    state: true,
    version: 0,
    cupsInUse: "",
    sectionsGroups: []
  };
  editComparationStr = "";
  invalidEdit = false;
  async mounted() {
    await this.getCups();
    await this.loadInfoGroupFieldsByName();
    await this.getRoles();
    await this.getIcons();
    await this.handleDocumentIdChange();
    this.loadAvailabilities();
  }

  @Watch("documentId")
  async handleDocumentIdChange() {
    this.campusChoosen = [];
    if ((this.documentId || "").length > 0) {
      this.closeSectionGroupDialog();
      this.docRef = this.documentId!;
      this.isEditing = true;
      this.TITLE = SERVICE_TEMP_CONSTANTS.TITLE.EDIT_TEMPLATE;
      this.isGettingTemplateData = true;
      await this.getServiceTemplateData(this.docRef);
      if (this.serviceTemplateFormData.cupsInUse) {
        await this.loadInactiveCups();
      }
      await this.loadInactiveCampusInUse();
      this.isGettingTemplateData = false;
      this.editComparationStr =
        JSON.stringify(this.serviceTemplateFormData) +
        JSON.stringify(this.availabilitiesChosen) +
        JSON.stringify(this.onlineAppointments) +
        JSON.stringify(this.fillByStep);
      this.invalidEdit = true;
    } else {
      this.isEditing = false;
      this.serviceTemplateFormData.sectionsGroups = [];
      this.addSectionGroupDialog = true;
      this.addSectionGroup(
        SERVICE_TEMP_CONSTANTS.LABEL.IDS.ADD_SECTION_GROUPS_COMPONENT,
        false
      );
      this.isGettingTemplateData = false;
    }
    this.goToStart(SERVICE_TEMP_CONSTANTS.LABEL.IDS.SAVE_SERVICE_ID);
  }
  @Watch("serviceType")
  checkServiceType() {
    this.serviceTemplateFormData.serviceType = this.serviceTypeModel[0].id;
  }
  @Watch("serviceCategory")
  checkServiceCategory() {
    this.serviceTemplateFormData.serviceCategory = this.categoryModel[0].id;
  }

  @Watch("serviceTemplateFormData", { deep: true })
  @Watch("availabilitiesChosen")
  @Watch("onlineAppointments")
  @Watch("fillByStep")
  checkEdit() {
    if (this.isEditing) {
      this.invalidEdit =
        JSON.stringify(this.serviceTemplateFormData) +
          JSON.stringify(this.availabilitiesChosen) +
          JSON.stringify(this.onlineAppointments) +
          JSON.stringify(this.fillByStep) ===
        this.editComparationStr;
    }
  }
  @Watch("cupsChosen")
  cupsChosenChange() {
    this.serviceTemplateFormData.cupsInUse =
      this.dynamicSelectList[0]?.id ?? "";
  }

  @Watch("serviceTemplateFormData.sectionsGroups")
  sectionGroupChange() {
    if (this.serviceTemplateFormData.sectionsGroups.length > 0)
      this.isEditingContent = true;
    else this.isEditingContent = false;
  }
  @Watch("campusServiceTemplate")
  watchCampusNewServiceValidation() {
    return this.campusServiceTemplate;
  }

  get cupsChosen() {
    return this.dynamicSelectList.length == 0
      ? new CupsPriceLevelHeader()
      : ((this.dynamicSelectList[0] as unknown) as CupsPriceLevelHeader);
  }

  get serviceType() {
    return this.serviceTypeModel[0].id;
  }

  set serviceType(id: string) {
    const option = this.serviceSelectConfig.listAll.find(item => item.id == id);
    this.serviceTypeModel = [
      { id: option?.id ?? "", name: option?.name ?? "" }
    ];
  }

  get serviceCategory() {
    return this.categoryModel[0].id;
  }

  set serviceCategory(id: string) {
    const option = this.categorySelectConfig.listAll.find(
      item => item.id == id
    );
    this.categoryModel = [{ id: option?.id ?? "", name: option?.name ?? "" }];
  }

  @Watch("availabilitiesChosen")
  async getCampus() {
    const responseData = await this.availabilityService.getCampusByAvailablityTemplateId(
      this.availabilitiesChosen.map(item => item.id)
    );

    if (responseData.code !== Http.Found || !responseData.data) {
      return;
    }

    this.campusChoosen = (responseData.data as CampusIdName[]).map(campus => ({
      id: campus._key!,
      name: campus.name!
    }));
  }

  async getServiceTemplateData(id: string) {
    try {
      const serviceTemp = await this.serviceTemplateService.getServiceTemplateById(
        id
      );

      if (serviceTemp.code === Http.Found && serviceTemp.data) {
        this.serviceTemplateFormData.multipleInstances =
          serviceTemp.data.multipleInstances ?? false;
        this.serviceTemplateFormData.serviceName =
          serviceTemp.data.internalName;
        this.serviceTemplateFormData.aliasName =
          serviceTemp.data.aliasName ?? "";
        this.serviceType = serviceTemp.data.type;
        this.serviceCategory = serviceTemp.data.category;
        this.serviceTemplateFormData.serviceType = serviceTemp.data.type;
        this.serviceTemplateFormData.serviceCategory =
          serviceTemp.data.category;
        this.serviceTemplateFormData.serviceDescription =
          serviceTemp.data.description;
        // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
        this.serviceTemplateFormData.serviceAvailabilityColor = serviceTemp.data.availabilityColor!;
        // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
        this.serviceTemplateFormData.serviceAvailabilityRecurrent = serviceTemp.data.availabilityRecurrent!;
        this.serviceTemplateFormData.colorPicked = this.serviceTemplateFormData.serviceAvailabilityColor;
        this.serviceTemplateFormData.state =
          serviceTemp.data.state == FORM_CONSTANTS.STATE.ACTIVE ? true : false;
        this.fillByStep = serviceTemp.data.fillByStep;
        this.onlineAppointments = serviceTemp.data.onlineAppointments
          ? true
          : false;
        this.serviceTemplateFormData.version = serviceTemp.data.version ?? 1;
        this.serviceTemplateFormData.cupsInUse = serviceTemp.data?.cups!;
        const cups = this.listCups.find(e => e.id == serviceTemp.data?.cups);

        this.fillAvailabilities(
          serviceTemp.data
            .availabilitiesTemplate as AvailabilityTemplateIdNameModel[]
        );

        if (cups) {
          this.dynamicSelectList = [(cups as unknown) as DynamicSelectData];
          this.dynamicSelectConfig.hint = this.cupHint;
        }

        if (
          this.serviceType == SERVICE_TEMP_CONSTANTS.TYPE.SECTIONS &&
          serviceTemp.data.sections
        )
          this.serviceTemplateFormData.sectionsGroups =
            serviceTemp.data.sections;
        else if (serviceTemp.data.groups)
          this.serviceTemplateFormData.sectionsGroups = serviceTemp.data.groups;

        this.onTypeChange();

        const campusValidation = this.watchCampusNewServiceValidation();

        if (campusValidation == true)
          store.commit(STORE_CONSTANTS.CAMPUS_SERVICE_TEMPLATE, false);
      } else {
        Snackbar.popError(serviceTemp.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICE_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  fillAvailabilities(availabilities: AvailabilityTemplateIdNameModel[]) {
    this.availabilitiesChosen = availabilities;
    availabilities.forEach(availability => {
      if (!this.availabilitiesStore.find(item => item.id === availability.id)) {
        this.availabilitiesStore.push(availability);
        this.availabilitySelectConfig.listAll.push({
          id: availability.id,
          name: availability.name
        });
      }
    });
    this.getCampus();
  }

  @Watch("serviceTypeModel")
  onTypeChange() {
    if (this.serviceType === SERVICE_TEMP_CONSTANTS.TYPE.GROUPS) {
      this.SECTIONS_GROUPS_TEXT = this.CLUSTER_TEXT;
      this.modalTitle = SERVICE_TEMP_CONSTANTS.MODAL_TITLE.GROUP;
      this.EMPTY_HEADER = SERVICE_TEMP_CONSTANTS.EMPTY_STATE.GROUP.HEADER;
      this.EMPTY_TEXT = SERVICE_TEMP_CONSTANTS.EMPTY_STATE.GROUP.TEXT;
      this.FILL_BY_STEP_LABEL =
        SERVICE_TEMP_CONSTANTS.LABELS_CREATE_TEMP.FILL_BY_STEP_LABEL +
        this.SECTIONS_GROUPS_TEXT.toLowerCase();
    } else {
      this.SECTIONS_GROUPS_TEXT = this.SECTION_TEXT;
      this.modalTitle = SERVICE_TEMP_CONSTANTS.MODAL_TITLE.SECTION;
      this.EMPTY_HEADER = SERVICE_TEMP_CONSTANTS.EMPTY_STATE.SECTION.HEADER;
      this.EMPTY_TEXT = SERVICE_TEMP_CONSTANTS.EMPTY_STATE.SECTION.TEXT;
      this.FILL_BY_STEP_LABEL =
        SERVICE_TEMP_CONSTANTS.LABELS_CREATE_TEMP.FILL_BY_STEP_LABEL +
        this.SECTIONS_GROUPS_TEXT.toLowerCase();
    }
  }

  addSectionGroup(id: string, onScroll: boolean) {
    this.sectionGroupFill = new SectionGroup();
    if (this.serviceType === SERVICE_TEMP_CONSTANTS.TYPE.SECTIONS) {
      this.sectionGroupFill.formTemplates = [];
    } else {
      this.sectionGroupFill.sessions = [];
    }

    this.addSectionGroupDialog = true;

    if (onScroll) {
      Utils.scrollToElement(id, this);
      Utils.moveElement(id, "sectionGroupContainer");
    }
  }

  editSectionGroup(index: number) {
    this.sectionGroupFill = this.serviceTemplateFormData.sectionsGroups[index];
    this.addSectionGroupDialog = true;
    this.indexEdit = index;
    this.activedScroll = true;
    this.deleteCounter++;
  }

  isSectionGroupOpen() {
    if (this.sectionGroupFill.name !== "") {
      Utils.moveElement(
        SERVICE_TEMP_CONSTANTS.LABEL.IDS.ADD_SECTION_GROUPS_COMPONENT,
        SERVICE_TEMP_CONSTANTS.LABEL.IDS.ADD_SECTION_GROUP + this.indexEdit
      );
    } else {
      Utils.moveElement(
        SERVICE_TEMP_CONSTANTS.LABEL.IDS.ADD_SECTION_GROUPS_COMPONENT,
        SERVICE_TEMP_CONSTANTS.LABEL.IDS.ADD_SECTION_GROUPS_CONTAINER
      );
    }
    if (this.activedScroll) {
      Utils.scrollToElement(
        SERVICE_TEMP_CONSTANTS.LABEL.IDS.ADD_SECTION_GROUPS_COMPONENT,
        this
      );
      this.activedScroll = false;
    }
  }

  closeSectionGroupDialog() {
    Utils.moveElement(
      SERVICE_TEMP_CONSTANTS.LABEL.IDS.ADD_SECTION_GROUPS_COMPONENT,
      SERVICE_TEMP_CONSTANTS.LABEL.IDS.ADD_SECTION_GROUPS_CONTAINER
    );
    this.sectionGroupFill = new SectionGroup();
    this.addSectionGroupDialog = false;
  }

  saveSectionGroup(section: SectionGroup) {
    this.serviceTemplateFormData.sectionsGroups.push(section);
    this.closeSectionGroupDialog();
  }

  updateSectionGroup(sectionUpdate: SectionGroup) {
    Vue.set(
      this.serviceTemplateFormData.sectionsGroups,
      this.indexEdit,
      sectionUpdate
    );
    this.closeSectionGroupDialog();
  }

  saveNewOrder() {
    for (
      let i = 0;
      i < this.serviceTemplateFormData.sectionsGroups.length;
      i++
    ) {
      const section = this.serviceTemplateFormData.sectionsGroups[i];
      section.order = i + 1;
      Vue.set(this.serviceTemplateFormData.sectionsGroups, i, section);
    }
  }

  deleteSectionGroup(index: number) {
    this.serviceTemplateFormData.sectionsGroups.splice(index, 1);
    this.saveNewOrder();
  }

  async handleCups(name: string, newCups?: boolean) {
    this.dynamicSelectConfig.loadingData = true;
    this.dynamicSelectConfig.notFound = false;
    const responseData = await this.cupsPriceLevelService.getCupsPriceLevelByFilter(
      { externalName: name, statesList: [this.ACTIVE_LABEL] }
    );

    this.dynamicSelectConfig.notFound = responseData.code === Http.NotFound;
    if (responseData.code === Http.Found && responseData.data) {
      await this.getCups();
      const SearchCups = responseData.data.cupsPriceLevels.map(item => {
        return {
          clients: item.clients,
          cups: item.cups,
          id: item.id,
          name: item.externalName,
          requiredPriorOrder: item.requiredPriorOrder,
          state: item.state
        };
      });

      this.dynamicSelectConfig.listAll = [
        ...this.dynamicSelectConfig.listAll,
        ...SearchCups
      ];
      if (newCups) {
        this.dynamicSelectList = [
          {
            id: responseData.data.cupsPriceLevels[0].id,
            name: responseData.data.cupsPriceLevels[0].externalName,
            state: responseData.data.cupsPriceLevels[0].state
          }
        ];
      }
    } else {
      this.dynamicSelectConfig.notFound = true;
    }
    this.dynamicSelectConfig.loadingData = false;
  }

  async getCups(name?: string) {
    try {
      const query: CupsPriceLevelFilter = {
        statesList: [this.ACTIVE_LABEL],
        paginatedResult: true,
        docref: this.cupsLastRef
      };

      if (name) {
        await this.handleCups(name);
        return;
      }

      const responseData = await this.cupsPriceLevelService.getCupsPriceLevelByFilter(
        query
      );
      if (this.dynamicSelectConfig.notFound) return;
      if (responseData.code === Http.Found && responseData.data) {
        if (this.cupsLastRef) {
          this.listCups = [
            ...this.listCups,
            ...responseData.data.cupsPriceLevels
          ];
        } else {
          this.listCups = responseData.data.cupsPriceLevels;
        }
        this.cupsLastRef = responseData.data.docref;
        this.dynamicSelectConfig.listAll = this.listCups as [];
      } else {
        this.listCups = [];
        this.dynamicSelectConfig.notFound = responseData.code === Http.NotFound;
      }
      this.dynamicSelectConfig.loadingData = false;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${CUPS_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
      this.listCups = [];
      this.dynamicSelectConfig.listAll = [];
    }
  }

  eventServiceCups(name: string, payload: boolean) {
    if (name && payload === true) {
      this.handleCups(name, payload as boolean);
    }
  }

  async saveService() {
    const serviceTemp: ServiceTemplateModel = {
      internalName: this.serviceTemplateFormData.serviceName,
      aliasName: this.serviceTemplateFormData.aliasName,
      type: this.serviceType,
      category: this.serviceCategory,
      description: this.serviceTemplateFormData.serviceDescription,
      state: this.serviceTemplateFormData.state
        ? FORM_CONSTANTS.STATE.ACTIVE
        : FORM_CONSTANTS.STATE.INACTIVE,
      fillByStep: this.fillByStep,
      cups: this.cupsChosen?.id ?? null,
      availabilityColor: this.serviceTemplateFormData.serviceAvailabilityColor,
      availabilityRecurrent: this.serviceTemplateFormData
        .serviceAvailabilityRecurrent,
      multipleInstances: this.serviceTemplateFormData.multipleInstances,
      version: this.serviceTemplateFormData.version,
      onlineAppointments: this.onlineAppointments,
      availabilitiesTemplate: this.availabilitiesChosen.map(
        availability => availability.id
      )
    };

    const user = localStorage.getItem(FORM_CONSTANTS.UID_TEXT) || "";
    const newSectionGroup: SectionGroup[] = [];

    if (this.serviceType === SERVICE_TEMP_CONSTANTS.TYPE.SECTIONS) {
      this.serviceTemplateFormData.sectionsGroups.forEach(sectionGroup => {
        const formsTempId = (sectionGroup.formTemplates as SectionGroupDetail[]).map(
          form => ({ id: form.id, multiple: form.multiple })
        );
        const newData = { ...sectionGroup, formTemplates: formsTempId };
        newSectionGroup.push(newData);
      });

      serviceTemp.sections = newSectionGroup;
    } else {
      this.serviceTemplateFormData.sectionsGroups.forEach(sectionGroup => {
        const sessionTempId = (sectionGroup.sessions as SectionGroupDetail[]).map(
          session => session.id
        );
        const newData = { ...sectionGroup, sessions: sessionTempId };
        newSectionGroup.push(newData);
      });

      serviceTemp.groups = newSectionGroup;
    }

    if (this.isEditing) {
      serviceTemp.changedBy = user;
      await this.updateServiceTemplate(serviceTemp);
    } else {
      serviceTemp.createdBy = user;
      await this.createServiceTemplate(serviceTemp);
    }
  }

  async createServiceTemplate(serviceTemplate: ServiceTemplateModel) {
    try {
      const exist = await this.serviceTemplateService.checkIfExistByName(
        serviceTemplate.internalName
      );

      if (exist.code === Http.NotFound) {
        const data = await this.serviceTemplateService.addServiceTemplate(
          serviceTemplate
        );

        if (data.code === Http.Ok) {
          Snackbar.popSuccess(
            SERVICE_TEMP_CONSTANTS.SNACKBAR_MESSAGES.SAVE_SUCCESS
          );
          this.$emit(EMITS.CLOSE);
        } else {
          Snackbar.popError(data.message);
        }
      } else if (exist.code === Http.Found) {
        Snackbar.popError(SERVICE_TEMP_CONSTANTS.SNACKBAR_MESSAGES.NAME_EXIST);
      } else {
        Snackbar.popError(exist.message);
      }
    } catch (error) {
      const METHOD = Utils.getMethodHTTP(
        error as AxiosError
      ) as keyof typeof SERVICE_TEMPLATES_ACCESS;
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICE_TEMPLATES_ACCESS[METHOD]}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async updateServiceTemplate(serviceTemplate: ServiceTemplateModel) {
    try {
      const data = await this.serviceTemplateService.updateServiceTemplate(
        this.docRef,
        serviceTemplate
      );

      if (data.code === Http.Ok) {
        Snackbar.popSuccess(
          SERVICE_TEMP_CONSTANTS.SNACKBAR_MESSAGES.SAVE_SUCCESS
        );
        this.$emit(EMITS.CLOSE);
      } else {
        Snackbar.popError(data.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST} ${SERVICES_ACCESS.PUT}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
      return;
    }
  }

  save() {
    if (this.serviceTemplateFormData.sectionsGroups.length === 0) {
      Snackbar.popWarning(SERVICE_TEMP_CONSTANTS.EMPTY_STATE.SECTION.HEADER);
      return;
    }

    this.modalConfirmationTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
    this.modalConfirmationText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
    this.dialogConfirmation = true;
  }

  cancel() {
    this.modalConfirmationTitle = FORM_MESSAGES.CANCEL_MODAL.TITLE;
    this.modalConfirmationText = FORM_MESSAGES.CANCEL_MODAL.MESSAGE;
    this.dialogConfirmation = true;
  }

  deleteSectionGroupModal(index: number) {
    this.indexDeleteSectionGroup = index;
    this.modalConfirmationTitle = FORM_MESSAGES.DELETE_MODAL.TITLE;
    this.modalConfirmationText = FORM_MESSAGES.DELETE_MODAL.MESSAGE;
    this.dialogConfirmation = true;
  }

  async handleModalAccept() {
    this.dialogConfirmation = false;
    if (this.modalConfirmationTitle === FORM_MESSAGES.CANCEL_MODAL.TITLE) {
      this.$emit(EMITS.CANCEL);
    }
    if (this.modalConfirmationTitle === FORM_MESSAGES.SAVE_MODAL.TITLE) {
      await this.saveService();
    }
    if (this.modalConfirmationTitle === FORM_MESSAGES.DELETE_MODAL.TITLE) {
      this.deleteCounter++;
      this.addSectionGroupDialog = false;
      this.deleteSectionGroup(this.indexDeleteSectionGroup);
    }
  }

  handleModalCancel() {
    this.dialogConfirmation = false;
  }

  openPreviewDialog() {
    const serviceTemp: ServiceTemplateModel = {
      internalName: this.serviceTemplateFormData.serviceName,
      type: this.serviceType,
      category: this.serviceCategory,
      description: this.serviceTemplateFormData.serviceDescription,
      state: this.serviceTemplateFormData.state
        ? FORM_CONSTANTS.STATE.ACTIVE
        : FORM_CONSTANTS.STATE.INACTIVE,
      cups: this.cupsChosen?.id,
      fillByStep: this.fillByStep,
      availabilityColor: this.serviceTemplateFormData.serviceAvailabilityColor,
      availabilityRecurrent: this.serviceTemplateFormData
        .serviceAvailabilityRecurrent,
      onlineAppointments: this.onlineAppointments,
      campus: this.campusChosen
    };

    if (this.serviceType === SERVICE_TEMP_CONSTANTS.TYPE.SECTIONS) {
      serviceTemp.sections = this.serviceTemplateFormData.sectionsGroups;
    } else {
      serviceTemp.groups = this.serviceTemplateFormData.sectionsGroups;
    }

    this.serviceTemplateDataStepper = serviceTemp;
    this.componentStepperViewerKey++;
    this.dialogStepperViewer = true;
  }

  closeStepperViewer() {
    this.dialogStepperViewer = false;
  }

  get isMultipleInstances() {
    return !this.cupsChosen?.requiredPriorOrder;
  }

  get cupHint() {
    return !this.cupsChosen?.requiredPriorOrder
      ? this.HINT_CUPS_NOT_REQUIRE_PRIOR_ORDER
      : this.HINT_CUPS_REQUIRE_PRIOR_ORDER;
  }

  get stateCup() {
    return this.cupsChosen?.state ?? "";
  }

  updateSelectList() {
    if (!this.isGettingTemplateData) {
      this.serviceTemplateFormData.multipleInstances = this.isMultipleInstances;
    }

    this.dynamicSelectConfig.hint = this.cupHint;
  }

  async loadInfoGroupFieldsByName() {
    try {
      const responseData = await this.infoGroupService.getInfoGroupFieldByName(
        INFO_GROUP_CONSTANTS.INFO_GROUP_BASIC_NAME
      );
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.userInfoParams = responseData.data;
      } else {
        Snackbar.popInfo(USER_TEMP_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_GROUPS);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${INFO_GROUPS_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  closeModalInfo() {
    this.dialogModalInfo = false;
  }

  async getRoles() {
    try {
      const responseData = await this.rolesService.getRoles(QUERY_STATE_ACTIVE);

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.userRoleList = responseData.data;
      } else {
        Snackbar.popInfo(USER_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_ROLES);
        this.userRoleList = [];
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${ROLES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getIcons() {
    try {
      const iconResponse = await this.managedListsService.getIconsImages(
        MANAGED_LISTS_TYPES.ICONS
      );

      this.iconsList = (iconResponse.data as Icon[]) || ICON_LIST_FIXED;
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  saveColor() {
    this.menu = false;
    this.serviceTemplateFormData.serviceAvailabilityColor = this.getColorPicked() as string;
  }

  getColorPicked() {
    if (typeof this.serviceTemplateFormData.colorPicked === "string") {
      return this.serviceTemplateFormData.colorPicked;
    }
    if (
      this.serviceTemplateFormData.colorPicked &&
      this.serviceTemplateFormData.colorPicked !== undefined
    ) {
      return (this.serviceTemplateFormData.colorPicked as { hexa: string })
        .hexa;
    }
  }

  async loadInactiveCups() {
    try {
      const inactiveCups = this.listCups.find(
        cups => cups.id === this.serviceTemplateFormData.cupsInUse
      )?.id;

      if (!inactiveCups) {
        const response = await this.cupsPriceLevelService.getCupsPriceLevelById(
          this.serviceTemplateFormData.cupsInUse
        );

        if (response.code === Http.Found && response.data !== undefined) {
          this.dynamicSelectConfig.listAll.push(({
            id: response.data.id,
            name: response.data.externalName,
            state: response.data.state
          } as unknown) as DynamicSelectData);
          this.dynamicSelectList = [
            {
              id: response.data.id!,
              name: response.data.externalName,
              state: response.data.state
            }
          ];
        }
      }
    } catch (err) {
      return [];
    }
  }

  async loadAvailabilities(availabilityName = "") {
    this.availabilitySelectConfig.notFound = false;

    if (availabilityName !== this.keyWordAvailabiltyName) {
      this.lastAvailabilityRef = "";
    }

    this.keyWordAvailabiltyName = availabilityName ?? "";

    try {
      this.availabilitySelectConfig.loadingData = true;
      const responseData = await this.availabilityTemplateService.getAvailabitiesTemplate(
        this.lastAvailabilityRef,
        availabilityName ?? ""
      );
      this.lastAvailabilityRef = responseData.data?.lastReference ?? "";
      this.availabilitySelectConfig.notFound =
        responseData.code === Http.NotFound;

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        if (this.lastAvailabilityRef) {
          this.availabilitiesStore = [
            ...this.availabilitiesStore,
            ...responseData.data.availabilitiesTemplates
          ];

          this.availabilitySelectConfig.listAll = [
            ...this.availabilitySelectConfig.listAll,
            ...responseData.data.availabilitiesTemplates.map(availability => ({
              id: availability.id,
              name: availability.name
            }))
          ];
        } else {
          this.availabilitiesStore = responseData.data.availabilitiesTemplates;
          this.availabilitySelectConfig.listAll = responseData.data.availabilitiesTemplates.map(
            availability => ({
              id: availability.id,
              name: availability.name
            })
          );
        }

        this.lastAvailabilityRef = responseData.data.lastReference;
      } else {
        this.availabilitySelectConfig.notFound = true;
        this.lastAvailabilityRef = "";
        Snackbar.popInfo(responseData.message);
      }
      this.availabilitySelectConfig.loadingData = false;
    } catch (error) {
      this.availabilitySelectConfig.loadingData = false;
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${AVAILIABILITY_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      this.campusFilters.docref = "";
      Snackbar.popError(errorMessage);
      return;
    }
  }

  async selectDefaultNewCampus() {
    store.commit(STORE_CONSTANTS.CAMPUS_SERVICE_TEMPLATE, false);
    this.listCampus.map(list => {
      const obj = {
        id: list._key,
        _key: list._key,
        name: list.name,
        state: list.state,
        address: list.address,
        countryCode: list.countryCode,
        phone: list.phone
      };
      this.campusChosen.push(obj);
    });
  }

  async loadInactiveCampusInUse() {
    const inactiveCampusInUse = this.listCampus
      .filter(campus => campus.state === STATE.INACTIVE)
      .map(campus => campus._key);

    try {
      if (inactiveCampusInUse.length === 0) {
        const response = await this.campusService.getCampusById(
          inactiveCampusInUse?.toString()
        );
        if (response.code === Http.Found && response.data) {
          this.listCampus.push(response.data);
        }
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${CAMPUS_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  selectAtLeastOneCampus() {
    return this.campusChosen.length > 0 || USER_MESSAGES.ONE_CAMPUS;
  }

  selectAtLeastOneAvailability() {
    return (
      this.availabilitiesChosen.length > 0 ||
      SERVICE_TEMP_CONSTANTS.MESSAGES.SELECT_AT_LAST_ONE_AVAILABILITY
    );
  }

  addElement(modal?: string) {
    switch (modal) {
      case SERVICE_TEMP_CONSTANTS.MODAL_TITLE.SECTION:
        this.showModalAddForm = true;
        break;
      case SERVICE_TEMP_CONSTANTS.MODAL_TITLE.GROUP:
        this.showModalAddSection = true;
        break;
      case PANEL_INFO_CONSTANTS.ACTION.SHOW_ADD_CAMPUS:
        Utils.changeStateList(this, USER_CONSTANTS.CAMPUS_SELECT, false);
        this.showModalCampus = true;
        break;
      case SERVICE_TEMP_CONSTANTS.AVAILABILITY:
        this.createAvailabilityTemplate();
        break;
      default:
        this.showModalAddCups = true;
        break;
    }
  }

  async createAvailabilityTemplate() {
    try {
      const availability: AvailabilityTemplate = {
        name: this.keyWordAvailabiltyName,
        dateCreated: new Date().getTime()
      };

      const response = await this.availabilityTemplateService.saveAvailabilityTemplate(
        availability
      );

      if (response.code === Http.Ok) {
        this.availabilitiesChosen.push({
          id: response.data as string,
          name: this.keyWordAvailabiltyName
        });
        Snackbar.popSuccess(
          SERVICE_TEMP_CONSTANTS.MESSAGES.AVAILABILITY_CREATED
        );
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${AVAILIABILITY_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  closeOptionsModal(modal: string) {
    this.modalMessage = modal;
    if (modal !== this.COMPONENT_NAME_MODAL.SESSION_TEMPLATE) {
      const modalUserTemplate: SearchContextModal = {
        componentName: modal,
        callbackHandleOperation: this.handleOperation
      };
      Utils.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL,
        modalUserTemplate
      );
    } else {
      this.onCloseSessionModal();
    }
  }

  async handleOperation(action: string) {
    if (action === LIST_DATA_EVENTS.CANCEL_DATA) {
      switch (this.modalMessage) {
        case COMPONENT_NAME_MODAL.CUPS_PRICE_LEVEL:
          this.onClosePriceLevelModal(false);
          break;
        case COMPONENT_NAME_MODAL.FORM_TEMPLATE:
          this.onCloseFormModal();
          break;
      }
    }
  }

  onClosePriceLevelModal(refreshList: boolean) {
    this.showModalAddCups = false;
    this.modalMessage = "";
    if (refreshList) this.getCups();
  }

  onCloseSessionModal() {
    this.showModalAddSection = false;
    this.modalMessage = "";
    this.refreshSessionSearch++;
  }

  onCloseFormModal() {
    this.showModalAddForm = false;
    this.modalMessage = "";
    this.refreshFormSearch++;
  }

  closeOnSave(modal: string) {
    switch (modal) {
      case COMPONENT_NAME_MODAL.CUPS_PRICE_LEVEL:
        this.onClosePriceLevelModal(true);
        break;
    }
  }

  async validateUniqueName() {
    this.errorsName = await Utils.checkUniqueName(
      COLLECTIONS_NAME.SERVICE_TEMPLATE,
      this.serviceTemplateFormData.serviceName
    );
  }
}
